document.addEventListener('DOMContentLoaded', function () {
  // Function to handle tab clicking in both desktop and mobile views
  function handleTabClick(tab) {
    // Get all tabs
    const tabs = document.querySelectorAll('.tab');
    const targetId = tab.getAttribute('data-target');

    // Remove active class from all tabs
    tabs.forEach(t => t.classList.remove('active'));

    // Add active class to clicked tab
    tab.classList.add('active');

    // Get all content sections
    const contentSections = document.querySelectorAll('.content-section');

    // Hide all content sections
    contentSections.forEach(section => {
      section.classList.remove('active');
    });

    // Show the targeted content section
    const targetContent = document.getElementById(targetId);
    if (targetContent) {
      targetContent.classList.add('active');
    }

    // Update dropdown title in mobile view
    const dropdownTitle = document.querySelector('.size-tabs-dropdown .accordion__title');
    if (dropdownTitle) {
      dropdownTitle.textContent = tab.textContent.trim();
    }

    // Close dropdown after selection in mobile
    const details = document.querySelector('.size-tabs-dropdown details');
    if (details) {
      details.removeAttribute('open');
    }
  }

  // Add click event listeners to all tabs
  const tabs = document.querySelectorAll('.tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      handleTabClick(this);
    });
  });

  // Set first tab as active on load if none is active
  const activeTab = document.querySelector('.tab.active');
  if (!activeTab && tabs.length > 0) {
    handleTabClick(tabs[0]);
  }
});
